// extracted by mini-css-extract-plugin
export default {"case-tip-menu":"styles_case-tip-menu__+cPin","tip-item":"styles_tip-item__kjET4"};